// Background videos get their poster and src only when about to scroll into
// view, so the page load doesn't pull them. Reduced motion keeps just the poster.
export function initLazyVideo() {
  const videos = document.querySelectorAll('video[data-lazy-video]');
  if (!videos.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      if (video.dataset.lazyPoster) video.poster = video.dataset.lazyPoster;
      if (!reducedMotion) {
        video.src = video.dataset.lazyVideo;
        video.play().catch(() => {});
      }
      observer.unobserve(video);
    });
  }, { rootMargin: '300px 0px' });

  videos.forEach((video) => observer.observe(video));
}
